<template>
  <v-card flat class="mb-4 pa-4" outlined>
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon left color="primary">mdi-email</v-icon>
      SMTP Provider Settings
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="smtpProvider"
        :items="smtpProviders"
        label="SMTP Provider"
        outlined
        dense
      />
      <div v-if="smtpProvider === 'gmail'">
        <v-text-field
          v-model="smtpConfig.user"
          label="Gmail Address"
          outlined
          dense
        />
        <v-text-field
          v-model="smtpConfig.pass"
          label="App Password"
          type="password"
          outlined
          dense
        />
      </div>
      <div v-else-if="smtpProvider === 'custom'">
        <v-text-field
          v-model="smtpConfig.host"
          label="SMTP Host"
          outlined
          dense
        />
        <v-text-field
          v-model="smtpConfig.port"
          label="SMTP Port"
          type="number"
          outlined
          dense
        />
        <v-switch
          v-model="smtpConfig.secure"
          label="Use SSL/TLS"
          color="primary"
        />
        <v-text-field
          v-model="smtpConfig.user"
          label="SMTP Username"
          outlined
          dense
        />
        <v-text-field
          v-model="smtpConfig.pass"
          label="SMTP Password"
          type="password"
          outlined
          dense
        />
      </div>
      <!-- Test SMTP Button and Dialog -->
      <v-divider class="my-4" />
      <v-row align="center">
        <v-col cols="12" md="8">
          <v-text-field
            v-model="testEmail"
            label="Test recipient email"
            dense
            outlined
            :disabled="testing"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            color="primary"
            @click="testSmtp"
            :loading="testing"
            :disabled="!testEmail || testing"
            block
          >
            <v-icon left>mdi-email-send</v-icon>
            Send Test Email
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="showTestDialog" max-width="600">
        <v-card>
          <v-card-title>
            <v-icon left color="primary">mdi-email-check</v-icon>
            SMTP Test Logs
          </v-card-title>
          <v-card-text style="max-height: 300px; overflow-y: auto">
            <div
              v-for="(log, idx) in testLogs"
              :key="idx"
              :style="{ color: log.type === 'error' ? 'red' : 'inherit' }"
            >
              <span v-if="log.type === 'step'">🟢</span>
              <span v-else-if="log.type === 'success'">✅</span>
              <span v-else-if="log.type === 'error'">❌</span>
              {{ log.message }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="showTestDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { apiConfig } from "@/config/api.config";
export default {
  name: "SmtpSettings",
  props: {
    value: Object,
  },
  data() {
    return {
      smtpProviders: [
        { text: "Gmail", value: "gmail" },
        { text: "Custom SMTP", value: "custom" },
      ],
      testEmail: "",
      testing: false,
      testLogs: [],
      showTestDialog: false,
    };
  },
  computed: {
    smtpProvider: {
      get() {
        return this.value.smtpProvider || "gmail";
      },
      set(val) {
        this.$set(this.value, "smtpProvider", val);
        if (val === "gmail") {
          this.$set(this.value, "smtpConfig", { user: "", pass: "" });
        } else if (val === "custom") {
          this.$set(this.value, "smtpConfig", {
            host: "",
            port: 465,
            secure: true,
            user: "",
            pass: "",
          });
        }
      },
    },
    smtpConfig: {
      get() {
        return this.value.smtpConfig || {};
      },
      set(val) {
        this.$set(this.value, "smtpConfig", val);
      },
    },
  },
  methods: {
    async testSmtp() {
      this.testing = true;
      this.testLogs = [{ type: "step", message: "Starting SMTP test..." }];
      this.showTestDialog = true;
      try {
        // Validate fields before sending
        if (!this.testEmail || !this.smtpProvider || !this.smtpConfig.user) {
          this.testLogs.push({
            type: "error",
            message: "Please fill all required SMTP fields and test email.",
          });
          this.testing = false;
          return;
        }
        // Compose config for backend
        const config = {
          smtpProvider: this.smtpProvider,
          smtpConfig: { ...this.smtpConfig },
          testEmail: this.testEmail,
        };
        this.testLogs.push({
          type: "step",
          message: "Sending request to server...",
        });
        // Use the correct /settings/smtp/test endpoint
        const res = await axios.post(
          `${apiConfig.baseURL}/settings/smtp/test`,
          config
        );
        if (res.data && Array.isArray(res.data.logs)) {
          this.testLogs = res.data.logs;
        } else {
          this.testLogs.push({
            type: "error",
            message: "Unexpected response from server.",
          });
        }
      } catch (e) {
        // Show backend logs if present
        if (
          e.response &&
          e.response.data &&
          Array.isArray(e.response.data.logs)
        ) {
          this.testLogs = e.response.data.logs;
        } else {
          this.testLogs.push({
            type: "error",
            message: e.response?.data?.message || e.message || "Test failed.",
          });
        }
      } finally {
        this.testing = false;
      }
    },
  },
};
</script>
